export var valuesPersonalInformationVisibility = ["Nobody", "Group", "Friends", "FriendAndGroup", "All"];
/*

*/ 
//# sourceMappingURL=PersonalInformationVisibility.js.map